import React from "react";

import { OutputRow as MeetingsDataFlattened } from "api/getMeetingsFlattened";
import { OutputRow as MeetingRequestsData } from "api/getMeetingRequests";
import { formatMeetingDetailsForAttendees } from "services/formatMeetingDetailsForAttendees";
import { useDefaultTimezone } from "hooks/useDefaultTimezone";

import SimpleTable from "components/SimpleTable";

export interface MeetingSummaryProps {
	event: MeetingsDataFlattened | MeetingRequestsData;
	currentUid: string;
}

const MeetingSummary: React.FunctionComponent<MeetingSummaryProps> = ({
	event,
	currentUid
}) => {
	const defaultTimezone = useDefaultTimezone();

	const {
		startDate,
		startTime,
		endTime,
		partnersName,
		medium,
		timezone
	} = formatMeetingDetailsForAttendees(
		event,
		currentUid,
		false,
		defaultTimezone
	);

	const rows = [
		[<strong>Date</strong>, startDate],
		[<strong>Time</strong>, `${startTime} until ${endTime} (${timezone})`],
		[<strong>With</strong>, partnersName],
		[<strong>Using</strong>, medium]
	];

	return <SimpleTable rows={rows} />;
};

export default MeetingSummary;
